import request from '@/utils/zsm-requets'
const sms = '/zsm/api/sms/'
/*
发送短信
 */
export function sendMsg(params) {
    return request({
        url: sms + 'sendMsg',
        method: 'post',
        params
    })
}


/*
校验短信
 */
export function validMsg(params) {
    return request({
        url: sms + 'validMsg',
        method: 'post',
        params
    })
}
